import { useId, useState } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * Sifre alani + goz ikonu.
 *
 * ## Ikonlar SVG ve incecik cizilmis
 *
 * Vanilla arayuzde ilk hali 17px + `stroke-width: 2` idi ve "guzel
 * cizilmemis" geri bildirimi geldi: cizgi kalinligi ikonu tikaniyordu.
 * 18px + 1.7 dogru denge. Ayrica sarmalayici `display: block` OLMAK ZORUNDA -
 * inline bir `<span>`da `position: relative` satir kutularina gore
 * hesaplandigi icin buton dikeyde kayiyor.
 *
 * ## `autoComplete` degerleri onemli
 *
 * `current-password` / `new-password` ayrimi sifre yoneticilerinin dogru
 * davranmasini sagliyor: `new-password` olmadan tarayici kayit formuna eski
 * sifreyi doldurup kullaniciyi "sifre zayif" hatasina sokuyor.
 */
export function PasswordField({
  label,
  value,
  onChange,
  autoComplete,
  required = true,
  invalid = false,
  describedBy,
}: {
  label: string
  value: string
  onChange(value: string): void
  autoComplete: 'current-password' | 'new-password'
  required?: boolean
  invalid?: boolean
  describedBy?: string
}) {
  const { t } = useTranslation()
  const id = useId()
  const [visible, setVisible] = useState(false)

  return (
    <div className="field">
      <label htmlFor={id}>{label}</label>
      <span className="pw-wrap">
        <input
          id={id}
          type={visible ? 'text' : 'password'}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          autoComplete={autoComplete}
          required={required}
          aria-invalid={invalid || undefined}
          aria-describedby={describedBy}
          minLength={10}
          maxLength={128}
        />
        <button
          type="button"
          className="pw-toggle"
          onClick={() => setVisible((current) => !current)}
          // Ekran okuyucu icin durum: yalnizca ikon degistirmek yetmez.
          aria-label={visible ? t('auth.field.passwordHide') : t('auth.field.passwordShow')}
          aria-pressed={visible}
          // Sekme sirasinda sifre alanindan sonra gelmesi dogru; atlanmasi
          // klavye kullanicisini ozellikten mahrum ederdi.
          tabIndex={0}
        >
          {visible ? <EyeOff /> : <Eye />}
        </button>
      </span>
    </div>
  )
}

function Eye() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="12" r="3.25" stroke="currentColor" strokeWidth="1.7" />
    </svg>
  )
}

function EyeOff() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M4 4l16 16"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
      <path
        d="M9.9 5.8A9.6 9.6 0 0 1 12 5.5c6 0 9.5 6.5 9.5 6.5a17 17 0 0 1-2.4 3.2M6.6 7.4A17.4 17.4 0 0 0 2.5 12S6 18.5 12 18.5c.9 0 1.7-.1 2.5-.4"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.6 9.9a3.25 3.25 0 0 0 4.5 4.5"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </svg>
  )
}
